import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue";
import { ref, watch } from 'vue';
import config from "../services/PortalConfig";
import CatalogCategoryViewV1 from "./CatalogCategoryViewV1.vue";
import CatalogCategoryViewV2 from "./CatalogCategoryViewV2.vue";
import userSettings, {} from "@astina/paloma-common-ui/src/services/UserSettings";
import events from "@astina/paloma-common-ui/src/services/EventBus";
import { useRoute, useRouter } from "vue-router";
import productRepository from "@astina/paloma-shop-common-ui/src/services/ProductRepository";
import alerts from "@astina/paloma-common-ui/src/services/Alerts";
import trans from "@astina/paloma-common-ui/src/services/Translator";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CatalogCategoryView',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const settings = userSettings('paloma-ui.portal.catalog');
        const uiSettings = ref(settings.get({ view: config.catalog.defaultView, viewMode: config.catalog.defaultViewMode }));
        let view = config.catalog.defaultView;
        if (config.catalog.allowCatalogViewSelection) {
            view = uiSettings.value.view || config.catalog.defaultView;
        }
        events.$on('catalog.select-view-mode', mode => {
            uiSettings.value.viewMode = mode;
            settings.set(uiSettings.value);
        });
        function toggleViewVersion() {
            uiSettings.value.view = uiSettings.value.view === 'v1' ? 'v2' : 'v1';
            settings.set(uiSettings.value);
            window.location.reload();
        }
        if (route.query['sku']) {
            redirectToRouteQuerySku();
        }
        watch(() => route.query['sku'], redirectToRouteQuerySku);
        function redirectToRouteQuerySku() {
            const sku = route.query.sku;
            if (!sku) {
                return;
            }
            productRepository.listVariants({
                filters: [{ attribute: 'sku', values: [sku], }],
            }, { number: 0, size: 1, }, [])
                .then(data => {
                if (data.content.length > 0) {
                    const item = data.content[0];
                    router.replace({
                        name: 'catalog_category_product_variant', params: {
                            id: item.attributes['itemNumber'],
                            sku: item.attributes['sku'],
                        },
                    });
                }
                else {
                    alerts.info(trans('catalog.sku_not_found', { sku: sku }));
                    router.push({ name: 'catalog' });
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_unref(view) === 'v1')
                    ? (_openBlock(), _createBlock(CatalogCategoryViewV1, { key: 0 }))
                    : (_unref(view) === 'v2')
                        ? (_openBlock(), _createBlock(CatalogCategoryViewV2, {
                            key: 1,
                            "view-mode": uiSettings.value.viewMode
                        }, null, 8, ["view-mode"]))
                        : _createCommentVNode("", true),
                _cache[1] || (_cache[1] = _createTextVNode()),
                (_unref(config).catalog.allowCatalogViewSelection)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (toggleViewVersion()), ["prevent"])),
                        href: "#",
                        class: _normalizeClass(["select-catalog-view", 'select-catalog-view--' + _unref(view)])
                    }, _toDisplayString(_ctx.$t('catalog.select_view_version.' + _unref(view))), 3))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
